import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";
import React from "react";

const BaseLink = ({ to, children, color = "primary", sx = {}, ...props }) => (
  <Link
    component={RouterLink}
    to={to}
    underline="hover"
    color={color}
    sx={{
      fontWeight: 500,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Link>
);

export default BaseLink;
